export default __webpack_public_path__ + "static/media/teacher07.2d31ba8a.jpg";